import { axios } from '../services/axios';

export default async function getServiceProfiles({ level, id }) {
    const result = await axios.get(`/serviceprofile/${level}/${id}`);
    return result;
}
